// extracted by mini-css-extract-plugin
export default {"button":"SmallButtons_button__-7gJx","primary":"SmallButtons_primary__u4SmP","terciary":"SmallButtons_terciary__hDZVH","secondary":"SmallButtons_secondary__73oaG"};